import { BoxProps } from "@mui/material";

export enum Action {
  Add = "Add",
  Remove = "Remove",
}

export type NftsPerTxSelectorProps = Omit<BoxProps, 'onChange'> & {
  onChange: (nftCount: number) => void
}